"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import WaveDropContent from "@/components/waves/drops/WaveDropContent";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { useRouter } from "next/navigation";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropSize } from "@/helpers/waves/drop.helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
interface WaveWinnersDropContentProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly isCompetitionDrop?: boolean | undefined;
}
export const WaveWinnersDropContent: React.FC<WaveWinnersDropContentProps> = t0 => {
  const $ = _c(9);
  const {
    winner,
    isCompetitionDrop: t1
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const router = useRouter();
  const [activePartIndex, setActivePartIndex] = useState(0);
  let t2;
  if ($[0] !== router) {
    t2 = drop => {
      const waveMeta = (drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      })?.chat;
      const href = getWaveRoute({
        waveId: drop.wave.id,
        serialNo: drop.serial_no,
        isDirectMessage: waveMeta?.scope?.group?.is_direct_message ?? false,
        isApp: false
      });
      router.push(href);
    };
    $[0] = router;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onDropContentClick = t2;
  let t3;
  if ($[2] !== winner.drop) {
    t3 = {
      type: DropSize.FULL,
      ...winner.drop,
      stableKey: winner.drop.id,
      stableHash: winner.drop.id
    };
    $[2] = winner.drop;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== activePartIndex || $[5] !== isCompetitionDrop || $[6] !== onDropContentClick || $[7] !== t3) {
    t4 = <WaveDropContent drop={t3} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onLongPress={_temp} onQuoteClick={_temp2} setLongPressTriggered={_temp3} isCompetitionDrop={isCompetitionDrop} />;
    $[4] = activePartIndex;
    $[5] = isCompetitionDrop;
    $[6] = onDropContentClick;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp() {}
function _temp2() {}
function _temp3() {}